import React from "react"
import * as classNames from "./Dialog.module.scss"
import Button from "../button/Button"
import Icon from "../icon/Icon"
import PropTypes from "prop-types"

const Dialog = ({ tag = "", className = "", children, ...otherProps }) => {
  const Tag = tag ? tag : "dialog"
  return (
    <>
      <Tag
        className={`${classNames.dialog} ${className}`}
        {...otherProps}
      >
        <form
          method="dialog"
          className={classNames.closeForm}
        >
          <Button aspect="unstyled">
            <Icon
              icon="cross"
              className={classNames.icon}
              width="16"
              height="15"
            />
          </Button>
        </form>
        {children}
      </Tag>
      {tag !== "dialog" && <div className={classNames.backdrop}></div>}
    </>
  )
}

Dialog.defaultProps = {
  tag: "dialog",
  className: "",
  children: null,
}

Dialog.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default Dialog
